import styled, { css } from 'styled-components';
import { mq } from '@utils/responsive';
import { H_PADDING_MOBILE } from '@utils/space';

import { TextWrapper } from '../block/Text/styles';
import colors from '../../utils/colors';
import { Heading as UnstyledHeading } from '@components/type';

export const Inner = styled.div`
  position: relative;
  z-index: 1;
  padding: 18px ${H_PADDING_MOBILE};

  ${mq.gtmd`
    padding: 0 calc((100vw - 1280px) / 2);
  `}
`;

export const Heading = styled(UnstyledHeading)`
  margin-bottom: 24px;
  color: ${(props) => props.outline && props.outline !== 'none' ?
  getThemeStyles(props.colorTheme).background :
  getThemeStyles(props.colorTheme).text};
  text-align: right;
  width: 100%;
  text-transform: uppercase;
  ${mq.gtsm`
    margin-bottom: 32px;
  `}
`;

export const Items = styled.div`
  margin: 24px;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  flex-wrap: wrap;
  ${mq.gtms`
      grid-template-columns: repeat(3, 1fr);
      margin: 24px 0;
  `}
`;

export const Image = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  height: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
`;

export const Item = styled.div`
  height: 100%;
  aspect-ratio: 4 / 5;
  position: relative;
  .youtube-iframe,
  .rsme-embed iframe,
  .tiktok-embed iframe,
  .instagram-media,
  .fb-post,
  .fb-post span,
  .fb-post iframe,
  [data-pin-log="embed_pin"],
  .twitter-tweet,
  .tiktok-embed {
    height: 100% !important;
    min-width: 100% !important;
    width: 100% !important;
    aspect-ratio: 4 / 5;
    overflow: hidden;
    padding: 0;
    margin: 0 !important;
  }
  .item_link {
    position: absolute;
  }
  svg path {
    fill: white;
  }
`;

export const Icon = styled.div`
  top: calc(50% - 21px);
  height: 28px;
`;

export const Wrapper = styled.div`
  position: relative;
  z-index: 0;
  transform: translate(0, 0);
  & > svg {
    fill: ${colors.G100};
    position: absolute;
    right: 100px;
    top: -200px;
    width: 400px;
    height: 400px;
    z-index: -1;
  }
  ${(props) => props.noPadding && css`
    ${TextWrapper}:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const SocialList = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 24px;
  ${mq.gtms`
      justify-content: start;
      margin-bottom: 0;
  `}
  > a {
    margin-top: 16px;
  }
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${mq.gtms`
      flex-direction: row;
  `}
`;

export function getThemeStyles(theme) {
  switch (theme) {
    case 'yellow':
      return {
        outline: colors.Y100,
        background: colors.Y100,
        fill: colors.Y200,
        text: colors.Y500,
      };
    case 'blue':
      return {
        outline: colors.B500,
        background: colors.B500,
        fill: colors.B200,
        text: colors.B500,
      };
    case 'purple':
      return {
        outline: colors.P500,
        background: colors.P500,
        fill: colors.P200,
        text: colors.P500,
      };
    case 'green':
      return {
        outline: colors.G100,
        background: colors.G100,
        fill: colors.G200,
        text: colors.G500,
      };
    case 'orange':
      return {
        outline: colors.O100,
        background: colors.O100,
        fill: colors.O200,
        text: colors.O500,
      };
    default:
      return {
        outline: colors.Y100,
        background: colors.Y100,
        fill: colors.Y200,
        text: colors.B500,
      };
  }
}
